/**
 * Created by denis.gusarov on 4/27/2017.
 */

namespace Factive.Game {
    import Tween = Factive.Core.Tween.Tween;
    import Easing = Factive.Core.Tween.Easing;
    import DependenciesContainer = Factive.Core.DependenciesContainer;

    export class GameView extends ViewBase {

        public $model: GameDataModel = null;
        private _diceBox: any;

        public constructor(private _options,
                           private _dc:DependenciesContainer) {
            super();
            this.$model = new GameDataModel(null);
            _dc.singleton("GameData", this.$model);
        }

        public static factory: any = {
            get (opt, dc): GameView {
                return new GameView(opt, dc);
            },
            dependency: ["Options", "DependenciesContainer"]
        };

        public getConfiguration(): IViewConfiguration {

            let childViews = {
                rollButtonView: {
                    view: "RollButtonView",
                    config: {
                        slot: "rollBtn"
                    },
                    options:<IRollButtonOptions>{
                        onPress: () => {
                            //this.$model.resultTable.rows.ones.x1 += 1;

                            this._diceBox.clear();
                            this._diceBox.start_throw((completeCallBackContext,result)=>{

                                this.$model.setDropDices(completeCallBackContext);

                            },this);

                            //this.$model.dropDices();
                        }
                    }
                },
                resultTableView: {
                    view: "ResultTableView",
                    model: this.$model.resultTable,
                    config: {
                        slot: "ResultTable"
                    }
                },
                woodenPanelView: {
                    view: "WoodenPanelView",
                    model: this.$model.selectedDice,
                    config: {
                        slot: "woodenPanel"
                    }
                },
                //dices
                // dice0: {
                //     view: "WoodenPanelCubeResultView",
                //     model: this.$model.droppedDice.dice0,
                //     x: -300,
                //     y: 100
                // },
                // dice1: {
                //     view: "WoodenPanelCubeResultView",
                //     model: this.$model.droppedDice.dice1,
                //     x: -200,
                //     y: 100
                // },
                // dice2: {
                //     view: "WoodenPanelCubeResultView",
                //     model: this.$model.droppedDice.dice2,
                //     x: -100,
                //     y: 100
                // },
                // dice3: {
                //     view: "WoodenPanelCubeResultView",
                //     model: this.$model.droppedDice.dice3,
                //     x: 0,
                //     y: 100
                // },
                // dice4: {
                //     view: "WoodenPanelCubeResultView",
                //     model: this.$model.droppedDice.dice4,
                //     x: 100,
                //     y: 100
                // }
            };

            for (let i = 0; i < 5; i++)
            {
                childViews["dice" + i] = {
                    view: "WoodenPanelCubeResultView",
                    model: this.$model.droppedDice["dice" + i],
                    y: 100,
                    x:(100*i-350)
                }
            }

            return <IViewConfiguration>{
                armatureName: "MainScene",
                childViews: childViews
            };
        }

        protected onContentLoaded(){
        }

        protected onSetLandscape(){

        }

        protected onSetPortrait(){

        }

        public onInitialize(): void {

            // var Dice = this._dc.get("Dice");
            //
            // this._diceBox = new Dice.dice_box(null, {w: 340, h: 320});
            // var texture_3D = PIXI.Texture.fromCanvas(this._diceBox.renderer.domElement);
            //
            // var sprite_3D = new PIXI.Sprite(texture_3D);
            // sprite_3D.scale.x = .5;
            // sprite_3D.scale.y = .5;
            // sprite_3D.anchor.set(.5,.5);
            // sprite_3D.x = -120;
            // sprite_3D.y = -30;
            // this.display.addChild(sprite_3D);
            // this._dc.singleton("sprite_3D",sprite_3D);

        }

        public hide(): any{
            let that = this;
            let alpha = {a:1};
            return new Promise(function(resolve, reject){
                let tweenPosition = new Tween(alpha)
                    .to({a: 0}, 300)
                    .easing(Easing.Cubic.InOut);
                tweenPosition.start();
                tweenPosition.onUpdate(() =>{
                    that.alpha = alpha.a;
                });
                tweenPosition.onComplete(() => {
                    resolve();
                });
            });
        }

        public show(): any{
            let that = this;
            let alpha = {a:0};
            return new Promise(function(resolve, reject){
                let tweenPosition = new Tween(alpha)
                    .to({a: 1}, 300)
                    .easing(Easing.Cubic.InOut);
                tweenPosition.start();
                tweenPosition.onUpdate(() =>{
                    that.alpha = alpha.a;
                });
                tweenPosition.onComplete(() => {
                    resolve();
                });
            });
        }
    }

}


// WEBPACK FOOTER //
// src/typescript/Game/Views/Game/GameView.ts